import { HTMLAttributes } from "react";
import { cn } from "../lib/utils";

export const Card = ({
	variant = "default",
	className,
	...props
}: {
	variant?: "square" | "rounded" | "default";
} & HTMLAttributes<HTMLDivElement>) => {
	return (
		<div
			className={cn(
				"flex flex-col",
				"gap-y-8 lg:gap-y-10",
				{
					"rounded-md": variant === "default",
					"rounded-none": variant === "square",
					"rounded-[50px]": variant === "rounded",
				},
				className,
			)}
			{...props}
		/>
	);
};

//** Container to hold the upper part of content */
export const CardHeader = ({
	className,
	...props
}: HTMLAttributes<HTMLDivElement>) => {
	return (
		<div className={cn("px-6 pt-6 lg:px-10 lg:pt-10", className)} {...props} />
	);
};

//** Title of the card */
export const CardTitle = ({
	className,
	...props
}: HTMLAttributes<HTMLHeadingElement>) => {
	return <h3 className={cn("!bb-text-display-h3", className)} {...props} />;
};

//** Description of the card */
export const CardDescription = ({
	className,
	...props
}: HTMLAttributes<HTMLParagraphElement>) => {
	return (
		<p className={cn("!bb-text-body !text-gray-4", className)} {...props} />
	);
};

//** Container to hold the lower part of content */
export const CardContent = ({
	className,
	...props
}: HTMLAttributes<HTMLDivElement>) => {
	return (
		<div
			className={cn("space-y-2 p-8 pt-0 lg:p-10 lg:pt-0", className)}
			{...props}
		/>
	);
};
